import {
  getValidSecondaryEnv,
  isNamedEnv,
  type NamedEnv,
} from '@mathflat/shared/@common/devToolbar'
import { domainProvider } from '@mathflat/shared/@common/domain/domainProvider'

import { strapi } from '~/@common/api/strapiApi'
import chatAxios from '~/@common/utils/chatAxios'
import maxios from '~/@common/utils/maxios'
import noxios from '~/@common/utils/noxios'
import { remoteStorageAxios } from '~/@common/utils/remoteStorageAxios'

export type LocalStorageDataT = {
  DEV_API: string
}

// api suffix: dev → '-dev', stg → '-staging', live → ''
const ENV_SUFFIX: Record<NamedEnv, string> = { dev: '-dev', stg: '-staging', live: '' }

const setSecondaryAxios = (env: NamedEnv) => {
  const d = domainProvider.TARGET_DOMAIN
  const s = ENV_SUFFIX[env]
  // strapi는 dev/stg 모두 hcms-staging, live만 hcms
  strapi.defaults.baseURL =
    env === 'live' ? `https://hcms.${d}/api` : `https://hcms-staging.${d}/api`
  remoteStorageAxios.defaults.baseURL = `https://remote-storage${s}.${d}`
  chatAxios.defaults.baseURL = `https://ai${s}.${d}`
  noxios.defaults.baseURL = `https://messaging-api${s}.${d}`
}

export const initAxiosDefaultBaseURL = (type: LocalStorageDataT['DEV_API'] | string) => {
  localStorage.setItem('DEV_API', type)

  if (isNamedEnv(type)) {
    maxios.defaults.baseURL = `https://api${ENV_SUFFIX[type]}.${domainProvider.TARGET_DOMAIN}`
    setSecondaryAxios(type)
    return
  }

  // custom URL: maxios만 커스텀, 보조 서버는 DEV_API_SECONDARY_ENV 기준
  maxios.defaults.baseURL = type
  setSecondaryAxios(getValidSecondaryEnv(localStorage.getItem('DEV_API_SECONDARY_ENV')))
}
